import { Switch } from "@/components/ui/switch";
// Note: Label import removed as it's not currently used
import { useUnitsPreference } from "@/hooks/useUnitsPreference";

export function UnitsToggle() {
  const { isMetric, toggleUnits, isLoading } = useUnitsPreference();

  return (
    <div className="flex items-center px-3 py-1.5 bg-white rounded-lg border border-neutral-200 shadow-sm">
      <div className="flex-1 mr-3">
        <label htmlFor="units-toggle" className="text-sm font-medium text-neutral-700">
          {isMetric ? "Metric Units" : "Imperial Units"}
        </label>
      </div>
      <Switch 
        id="units-toggle" 
        checked={isMetric}
        onCheckedChange={toggleUnits}
        disabled={isLoading}
      />
    </div>
  );
}